<template>
	<div class="ma-0 pa-0 menu-table-root pb-1">
		<v-data-table
		:headers="headers"
		dense
		fixed-header
		:items="visibleMenus"		   
		class="elevation-1 menu-table"
		disable-pagination
		hide-default-footer
		height="100%"
		width="100%"				
		item-key="id"
        style="width:100%;height:100%;"
		v-model="selectedMenu"
		>
			<template v-slot:item.code="{ item }">
				<v-container  class="pt-4">
				<v-row>
					<v-col class="px-0">
						<template v-for="n in item.level-1" >&#12288;</template>
					</v-col>
					<v-col class="mr-0">
						<v-icon v-if="canOpen(item)" v-on:click="openMenu(item)">mdi-plus-box-outline</v-icon>
						<v-icon v-else-if="canClose(item)"  v-on:click="closeMenu(item)">mdi-minus-box-outline</v-icon>
						<v-icon v-else>mdi-border-none-variant</v-icon>
					</v-col>
					<v-col class="pl-0 pr-1 mx-0">
						<v-icon v-if="item.selectState==1" v-on:click.stop.prevent="doUnSelectMenu(item)">mdi-checkbox-marked</v-icon>
						<v-icon v-else-if="item.selectState==-1" v-on:click.stop.prevent="doSelectMenu(item)">mdi-checkbox-blank-outline</v-icon>
						<v-icon v-else v-on:click.stop.prevent="doSelectMenu(item)">mdi-checkbox-intermediate</v-icon>						
					</v-col >
					<v-col class="px-0 code-item">
						{{ item.code}}
					</v-col>					
				</v-row>
				</v-container>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {default as AppApi} from "../../../../api/smp/sys/AppApi.js";
	import {default as MenuApi} from "../../../../api/smp/sys/MenuApi.js";
	import {default as AuthManageApi} from "../../../../api/smp/sys/AuthManageApi.js";
	
	export default {
		name: 'MenuAuthTable',
		components: {
		},
		data: () => ({
			headers:[
				
				{ text: '代号', value: 'code',sortable: false ,width:400,divider:true},
				{text: '编号',align: 'start',sortable: false,value: 'id',width:100,divider:true},
				{ text: '名称', value: 'name',sortable: false ,width:200,divider:true},	
				{ text: '标题', value: 'title',sortable: false ,width:200,divider:true},	
				{ text: '类型', value: 'typeName',sortable: false ,width:100,divider:true},
				{ text: '末级', value: 'isLeaf',sortable: false ,width:50,divider:true},
				{ text: '排序号', value: 'orderNum',sortable: false ,width:80,divider:true},
				{ text: '图标CSS', value: 'iconCssCls',sortable: false ,width:200,divider:true},
				{ text: '模块', value: 'moduleName',sortable: false ,width:200,divider:true},
				{ text: '功能名称', value: 'funcName',sortable: false ,width:200,divider:true},
				{ text: '组件/页面路径', value: 'funcPath',sortable: false ,width:200,divider:true}
				
			],
			menus:[],			
			visibleMenus:[],
			selectedMenu:[],  //菜单权限全部只保存最末级
			editing:false,
			menuMap:null,
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			getSelectedMenus(){
				let me = this;
				let selected = [];
				this.menus.forEach(function(item){
					me.collectSelected(selected,item);
				});
				return selected;
			},
			collectSelected(selected,menu){
				let me = this;
				if(menu.selectState==1)
					selected.push(menu);
				if(menu.lower){
					menu.lower.forEach(function(item){
						me.collectSelected(selected,item);
					});
				}
			},
			setEditing(editing){
				this.editing = editing;
			},
            clear(){
                this.menus = [];
				this.visibleMenus=[];
                this.selectedMenu=[];
                if(this.menuMap && this.menuMap.clear)
                    this.menuMap.clear();
            },
			async loadMenus(appId){
				let me = this;
				if(!appId)
					return;
				let resp = await MenuApi.queryByAppId(appId);

				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取菜单信息失败':msg;
					throw new Error(msg);
					return;
				}
				let menus = data.data.menus;	
				menus = me.genTree(menus);		
				me.customMenus(menus);
				
				me.levelMenus(menus,1,null);													
				me.menus = menus;
				me.collectVisibleMenus();
				
			},
			async loadOperGroupPriviledgeMenuLeafAndButton(appId,operGroupId){
				let me = this;
				let resp = await AuthManageApi.queryOperGroupPriviledgeMenu(appId,operGroupId);

				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取菜单权限信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let menus = data.data.previledgeMenus;	
				console.log("priviledge menus loaded.");
				console.log(menus);
				menus.forEach(function(item){
					let menu = me.menuMap.get(item.code);
					if(menu)
						me.selectMenuState(menu,1,false,true);
				});

			},
			customMenus(menus){
				let me =this;
				menus.forEach(function(item){
					if(item && item.leafFlag && (item.leafFlag==1))
						item.isLeaf = '是';
					else
						item.isLeaf = '否';	
					if(item.lower){
						me.customMenus(item.lower)
					}					
				});
				
			},
			doSelectMenu(menu){
				if(!this.editing)
					return;
				if(menu){
					if(menu.lower){
						//由下级元素调整状态的过程中自动调整父元素，本级元素不需要触发
						this.selectLowerMenuState(menu,1,true,false);
					}
					this.selectMenuState(menu,1,false,true);
				}
			},
			doUnSelectMenu(menu){
				if(!this.editing)
					return;
				if(menu){
					if(menu.lower){
						this.selectLowerMenuState(menu,-1,true,false);
					}
					this.selectMenuState(menu,-1,false,true);
				}
			},
			setOriSelectMenus(menu){
				
				
			},

			selectLowerMenuState(menu,state,cascadeChildren,needCheckParentState){
				let me = this;
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
				//先选中所有子节点
				if(menu.lower){
					menu.lower.forEach(function(item){
						item.selectState = state;
						me.selectMenuState(item,state,cascadeChildren,needCheckParentState);
					});
				}
			},
			selectMenuState(menu,state,cascadeChildren,needCheckParentState){
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
					
				if(cascadeChildren==true){
					this.selectLowerMenuState(menu,state,cascadeChildren,needCheckParentState);
				}
				menu.selectState = state;
				if(needCheckParentState){
					this.selectCheckParentNode(menu,needCheckParentState);
				}
			},
			selectCheckParentNode(menu,cascadeParent){
				let me =this;
				let parentMenu = this.getParentMenu(menu);
				if(parentMenu){
					if(this.getChildrenAllSelectedState(parentMenu)==1)
						parentMenu.selectState = 1;
					else if(this.getChildrenAllSelectedState(parentMenu)==-1)	
						parentMenu.selectState = -1;
					else
						parentMenu.selectState = 0;
					if(cascadeParent)	
						me.selectCheckParentNode(parentMenu,cascadeParent);
				}
			},
			//0部分选择 1 全部选择 -1全部未选
			getChildrenAllSelectedState(menu){
				let foundSelected = false;
				let foundUnSelected = false;
				let foundSomeSelected = false;
				menu.lower.forEach(function(item){
					if((item.selectState)&&(item.selectState==1))
						foundSelected = true;
					else if((item.selectState)&&(item.selectState==-1))
						foundUnSelected = true;
					else
						foundSomeSelected = true;
						
				});
				if(((foundSelected==true)&&(foundUnSelected==true))||(foundSomeSelected==true))
					return 0;
				else if(foundSelected)
					return 1;
				return -1;	
			},
			getParentMenu(menu){
				let lenPerLevel=4;
				let parentMenuCode = menu.code.substr(0,menu.code.length-1*lenPerLevel);
				return this.menuMap.get(parentMenuCode);				
			},
			
			genTree(menus){
				let lenPerLevel=4;
				let me = this;
				let result = [];
				let map = new Map();
				let orderedMenu =  menus.sort(me.compareMenu);
				
				//let orderedMenu = menus;
				orderedMenu.forEach(function(item){
					let code = item.code;
					item.lower = [];
					item.selectState=-1;
					if(code.length==1*lenPerLevel)
						result.push(item);
					else{
						let parentItem = map.get(code.substr(0,code.length-1*lenPerLevel));
						if(parentItem){
							parentItem.lower.push(item);
						}
					}	
					map.set(code,item);
				});
				this.menuMap = map;
				return result;
			},
			compareMenu(menu1,menu2){
				let res = 0;
				if((menu1.code.length<menu2.code.length) || (menu1.code.length==menu2.code.length && menu1.code<menu2.code))
					res = -1;
				else 
					res = 1;
				return res;
			},
			levelMenus(menus,level,higherMenu){
				let me = this;
				
				menus.forEach(function(item){
					me.menus.push(item);
					item.higher = higherMenu;
					item.level = level;
					item.opened = false;		
					if(item.lower)
						me.levelMenus(item.lower,level+1,item);		
						
				});
			},
			canOpen(menu){
				return this.hasLower(menu)&&(!menu.opened);
			},
			canClose(menu){
				return this.hasLower(menu)&&(menu.opened);
			},
			hasLower(menu){
				return menu && menu.lower && menu.lower.length && menu.lower.length>0 ;
			},
			openMenu(menu){
				menu.opened = true;
				this.collectVisibleMenus();
			},
			closeMenu(menu){
				menu.opened = false;
				this.collectVisibleMenus();
			}, 
			menuVisible(menu){
				if(!menu.higher)
					return true;
				return menu.higher.opened;	
			},
			collectVisibleMenu(visible,menu){
				let me = this;
				if(me.menuVisible(menu)){
					visible.push(menu);
					if(menu.lower){
						menu.lower.forEach(function(item){
							me.collectVisibleMenu(visible,item);
						});
					}
				}
			},
			collectVisibleMenus(){
				let visible = [];
				let me = this;
				me.menus.forEach(function(item){
					me.collectVisibleMenu(visible,item);
				});				
				me.visibleMenus=visible;
			},
		},
		computed:{	
			
		},		
		created(){
		}
	}
</script>

<style scoped>
	.menu-table-root{
		
	}
	.menu-table{
		
	}
	.code-item{
		flex-grow: 100;
	}
</style>
